// extracted by mini-css-extract-plugin
export default {"root":"---------packages-corgi-x-src-components-Page-BaseNav-BaseNav-module__root"};